import Vue from 'vue'
import './registerServiceWorker'
import pinia from '@plugins/pinia'
import vuetify from '@plugins/vuetify'
import router from './router'
import App from './App.vue'
import '@/plugins/components'
import '@/plugins/icons'
import '@/plugins/perfect-scrollbar'
import '@/plugins/portal'
import '@/plugins/vjsf'
import '@core/plugins/numeral'
import '@core/plugins/supabase'
import '@core/plugins/axios'
import '@core/plugins/acl'
import '@/plugins/mask'
import '@/plugins/kanban'
import '@/plugins/socket'
import '@/plugins/moment'

Vue.config.productionTip = false

new Vue({
  router,
  pinia,
  vuetify,
  render: h => h(App),
}).$mount('#app')
